import { pipe, catchError } from 'overmind';

import type { Context } from '@/overmind';
import { getRequestAborter } from '@/overmind/effects/requestAborter';
import { UnexpectedStateError, AbortError } from '@/overmind/errors';

const { switchToNewRequest, completeRequestOperator } =
  getRequestAborter('loadFeatureTypes');

export const loadFeatureTypes = pipe(
  async ({ state, effects }: Context) => {
    const abortController = switchToNewRequest();
    const adapter = effects.arcgisMapAdapter.getAdapter();
    const layerIds = state.arcgis.config.value?.mapSource.layerIds;
    if (adapter && layerIds) {
      state.arcgis.featureTypes.send('TRIGGER_LOADING');
      return adapter.getSubtypes(layerIds, abortController);
    }

    throw new UnexpectedStateError();
  },
  ({ state }: Context, subTypes) => {
    state.arcgis.featureTypes.send('FETCH_SUCCESS', subTypes);
  },
  catchError(({ state }: Context, error) => {
    if (
      !(error instanceof UnexpectedStateError || error instanceof AbortError)
    ) {
      state.arcgis.featureTypes.send('FETCH_ERROR', error.message);
    }
  }),
  completeRequestOperator()
);

export const resetFeatureTypesState = pipe(async ({ state }: Context) => {
  state.arcgis.featureTypes.send('UNLOAD');
});
